import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class OrganizationResource extends AuthenticatedResource {
  static urlRoot = '/organizations' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}
